import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import tryout from './modules/tryout'
import datatable from './modules/datatable'
import tryoutgroup from './modules/tryout_group'
import usman from './modules/usman'
import video from './modules/video'
import bimbel from './modules/bimbel'
import content from './modules/content'
import error from './modules/error'
import ads from './modules/ads'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    tryout,
    datatable,
    tryoutgroup,
    usman,
    video,
    bimbel,
    error,
    ads,
    content
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js